export default __webpack_public_path__ + "static/media/dia6.d2792be8.png";